<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu danh sách tài sản đơn vị đã gửi lên CSDLQG</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Đơn vị quản lý:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Tên tài sản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.assetName" placeholder="Nhập tên tài sản ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Mã tài sản tại kho:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.assetCode" placeholder="Nhập mã tài sản ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Nhóm tài sản:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-model="searchForm.assetTypeGroupId" allowClear
                                             placeholder="--- Tất cả ---"
                                             :options="listAssetTypeGroups" />
                                </b-form-group>
                            </b-col>

                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.syncStartDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.syncEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Quyết định từ ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.decisionStartDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>

                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đến ngày:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.decisionEndDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Số QĐ tịch thu/ xác lập:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" v-model="searchForm.decisionNumber" placeholder="Nhập số quyết định ..."></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col md="6"></b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <div class="form-group">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                    <b-button type="button" @click="exportExcel(0)" variant="primary" title="Xuất excel các trường hiển thị như grid">Xuất excel</b-button>
                                    <!--<b-button type="button" @click="exportExcel(1)" variant="primary" title="Xuất excel tất cả các trường">Xuất excel đầy đủ trường</b-button>-->
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :isRowSelectable="isDataOwner"
                            dataUrl="data/national-public-assets"
                            gridName="Danh sách tài sản"
                            ref="nationalPublicAssetsTable">
                        <template v-slot:actions v-if="hasDeletePermission">
                            <!--<b-button size="md" @click.stop="removeSelected" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.item.syncSourceType) }}
                        </template>
                        <template v-slot:cell(syncDate)="row">
                            {{ row.item.syncDate | formatTime }}
                        </template>
                        <template v-slot:cell(decisionDate)="row">
                            {{ row.item.decisionDate | formatDate }}
                        </template>
                        <template v-slot:cell(assetValue)="row">
                            {{ row.item.assetValue | currency }}
                        </template>
                        <template v-slot:cell(area)="row">
                            {{ row.item.area | formatNumber }} m
                            <sup>2</sup>
                        </template>
                        <template v-slot:cell(volume)="row">
                            {{ row.item.volume | formatNumber }} g
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <b-button v-if="authorize(['ViewNationalPublicAsset'])" size="sm" :to="{ path: `./${row.item.id}` }" title="xem" variant="info">
                                    Xem
                                </b-button>
                                <b-button v-if="isDataOwner(row.item)" size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                    Xoá
                                </b-button>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    export default {
        name: 'ListSyncedNationalPublicAssets',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    assetCode: null,
                    assetName: null,
                    syncStartDate: null, //new Date().firstDayOfMonth().formatDate(),
                    syncEndDate: new Date().formatDate(),
                    assetTypeGroupId: null,
                    assetSourceId: null,
                    decisionNumber: null,
                    decisionName: null,
                    decisionStartDate: null,
                    decisionEndDate: new Date().formatDate(),
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    syncUnitType: 0,
                    syncSourceType: this.getSyncSourceTypeCache(),
                },
                gridOptions: {
                    fields: [
                        { key: 'syncId', label: 'Mã tài sản tại PM nghiệp vụ', sortable: true, sortDirection: 'asc' },
                        { key: 'code', label: 'Mã tài sản tại kho', sortable: true, sortDirection: 'asc' },
                        { key: 'assetName', label: 'Tên tài sản', sortable: true, sortDirection: 'asc' },
                        { key: 'unitName', label: 'Đơn vị quản lý', sortable: true, sortDirection: 'asc', tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        //{ key: 'syncUnitName', label: 'Đơn vị đồng bộ', sortable: true, tdAttr: (key, value, item) => ({ title: item.syncUnitFullName }) },
                        //{ key: 'assetSourceName', label: 'Nguồn gốc tài sản', sortable: true, sortDirection: 'asc' },
                        //{ key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true, sortDirection: 'asc' },
                        { key: 'assetTypeName', label: 'Nhóm tài sản', sortable: true, sortDirection: 'asc' },
                        { key: 'assetValue', label: 'Tổng GT tịch thu/ xác lập', sortable: true, tdClass: 'text-right' },
                        //{ key: 'quantity', label: 'Số lượng', sortable: true },
                        //{ key: 'volume', label: 'Khối lượng', sortable: true },
                        //{ key: 'area', label: 'Diện tích', sortable: true },
                        { key: 'syncDate', label: 'Ngày đồng bộ', sortable: true, sortDirection: 'asc' },
                        { key: 'decisionNumber', label: 'QĐ tịch thu/ xác lập', sortable: true },
                        { key: 'decisionName', label: 'Tên vụ việc', sortable: true },
                        { key: 'decisionDate', label: 'Ngày quyết định', sortable: true },
                    ],
                    sortBy: 'syncDate',
                    sortDesc: true
                },
                isShowBtnDelete: true
            }
        },
        computed: {
            ...mapState({
                listAssetTypeGroups: (state, getters) => state.common.assetTypeGroups.filter(x => x.parentId == 2).map(x => { return { id: x.id, text: x.name }; }),
                // Lọc Nguồn gốc tài sản theo nhóm tài sản lớn là tài sản xác lập sở hữu toàn dân có id = 2
                listAssetSources: (state, getters) => getters.assetSourceTree.filter(x => x.appliedAssetTypeGroupIds != undefined && x.appliedAssetTypeGroupIds.indexOf(2) != -1)
            }),
            hasDeletePermission() {
                return this.authorize(['ManageNationalPublicAsset']);
            }
        },
        created() {
            //this.searchForm.unitId = this.$store.state.identity.unitId || 1;
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.nationalPublicAssetsTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.nationalPublicAssetsTable.refresh();
            },
            isDataOwner(row) {
                return this.authorize(['ManageNationalPublicAsset'], row.syncUnitId);
            },
            remove(item, index, button) {
                var vm = this;
                if (confirm('Bạn có chắc chắn muốn xóa tài sản này?')) {
                    this.$services.delete(`data/national-public-assets/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa tài sản thành công');
                        vm.search();
                    });
                }
            },
            removeSelected() {
                var vm = this;
                var selectedRows = this.$refs.nationalPublicAssetsTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các tài sản này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`data/national-public-assets?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa các tài sản thành công');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn tài sản cần xóa');
                }
            },
            exportExcel(type) {
                //if (!this.searchForm.unitId) {
                //    this.searchForm.unitId = this.$store.state.identity.unitId;
                //}
                if (type == 0) {
                    this.$services.download2(`data/national-public-assets/export`, this.searchForm);
                }
                else {
                    this.$services.download2(`data/national-public-assets/export-all-fields`, this.searchForm);
                }
            }
        }
    }
</script>
<style scoped>
    .w30 {
        width: 30px;
    }
</style>
